import { DarkTheme, DefaultTheme, type Theme } from 'expo-router/react-navigation';

export const THEME = {
  light: {
    background: 'hsl(0 0% 98%)',
    foreground: 'hsl(0 0% 10.2%)',
    card: 'hsl(0 0% 100%)',
    cardForeground: 'hsl(0 0% 10.2%)',
    popover: 'hsl(0 0% 100%)',
    popoverForeground: 'hsl(0 0% 10.2%)',
    primary: 'hsl(20 100% 50%)',
    primaryForeground: 'hsl(0 0% 100%)',
    secondary: 'hsl(0 0% 10.2%)',
    secondaryForeground: 'hsl(0 0% 100%)',
    muted: 'hsl(0 0% 92%)',
    mutedForeground: 'hsl(0 0% 31%)',
    accent: 'hsl(20 100% 94%)',
    accentForeground: 'hsl(0 0% 10.2%)',
    destructive: 'hsl(0 74% 50%)',
    destructiveForeground: 'hsl(0 0% 100%)',
    border: 'hsl(0 0% 80%)',
    input: 'hsl(0 0% 80%)',
    ring: 'hsl(20 100% 50%)',
    radius: '0.375rem',
    chart1: 'hsl(20 100% 50%)',
    chart2: 'hsl(0 0% 10.2%)',
    chart3: 'hsl(0 0% 100%)',
    chart4: 'hsl(142 65% 32%)',
    chart5: 'hsl(0 74% 50%)',
  },
  dark: {
    background: 'hsl(0 0% 10.2%)',
    foreground: 'hsl(0 0% 100%)',
    card: 'hsl(0 0% 14%)',
    cardForeground: 'hsl(0 0% 100%)',
    popover: 'hsl(0 0% 14%)',
    popoverForeground: 'hsl(0 0% 100%)',
    primary: 'hsl(20 100% 50%)',
    primaryForeground: 'hsl(0 0% 100%)',
    secondary: 'hsl(0 0% 100%)',
    secondaryForeground: 'hsl(0 0% 10.2%)',
    muted: 'hsl(0 0% 20%)',
    mutedForeground: 'hsl(0 0% 76%)',
    accent: 'hsl(20 100% 19%)',
    accentForeground: 'hsl(0 0% 100%)',
    destructive: 'hsl(0 70% 55%)',
    destructiveForeground: 'hsl(0 0% 100%)',
    border: 'hsl(0 0% 30%)',
    input: 'hsl(0 0% 30%)',
    ring: 'hsl(20 100% 50%)',
    radius: '0.375rem',
    chart1: 'hsl(20 100% 50%)',
    chart2: 'hsl(0 0% 100%)',
    chart3: 'hsl(0 0% 10.2%)',
    chart4: 'hsl(142 65% 46%)',
    chart5: 'hsl(0 70% 60%)',
  },
};

export const NAV_THEME: Record<'light' | 'dark', Theme> = {
  light: {
    ...DefaultTheme,
    colors: {
      background: THEME.light.background,
      border: THEME.light.border,
      card: THEME.light.card,
      notification: THEME.light.destructive,
      primary: THEME.light.primary,
      text: THEME.light.foreground,
    },
  },
  dark: {
    ...DarkTheme,
    colors: {
      background: THEME.dark.background,
      border: THEME.dark.border,
      card: THEME.dark.card,
      notification: THEME.dark.destructive,
      primary: THEME.dark.primary,
      text: THEME.dark.foreground,
    },
  },
};
